<script lang="ts">
  import { isMobile } from '$stores/media.store';
  export let title: any = '';
  export let id: string = 'default';
  export let navBar: boolean = false;
  export let dontSetXY: boolean = false;
  export let noArrow: boolean = false;
  export let invertX: boolean = false;
  export let x: number | null = null;
  export let y: number | null = null;

  let isHovered = false;
  let tooltipContainer: HTMLElement;

  function mouseOver(event) {
    if (!$isMobile) {
      isHovered = true;
    }
  }
  function mouseMove(event) {
    if (!$isMobile) {
      let elementRect = document.querySelector('#' + id)?.getBoundingClientRect();

      if (dontSetXY == false) {
        if (invertX) {
          x =
            window.scrollX +
            elementRect?.left -
            tooltipContainer?.getBoundingClientRect().width -
            10;
        } else {
          x = window.scrollX + elementRect?.left + 40;
        }

        y = window.scrollX + elementRect?.top + elementRect?.height / 2 - 10;

        if (navBar) {
          x += 28;
          y -= 8;
        }
      }
    }
  }
  function mouseLeave() {
    if (!$isMobile) {
      isHovered = false;
    }
  }
</script>

<!-- svelte-ignore a11y-mouse-events-have-key-events -->
<!-- svelte-ignore a11y-click-events-have-key-events -->
<button
  on:mouseover={mouseOver}
  on:mouseleave={mouseLeave}
  on:click={mouseLeave}
  on:mousemove={mouseMove}
  aria-label={title}
  {id}
>
  <slot />
  {#if isHovered}
    <div
      bind:this={tooltipContainer}
      class="fixed z-[51] flex flex-row items-center"
      style="top: {y}px; left: {x}px;"
    >
      {#if !invertX && !noArrow}
        <div class="arrow-left -mr-0.5" />
      {/if}

      <div class="rounded-10 backdrop-blur-2xl bg-[#00000080] p-2 text-white font-normal text-base">
        <slot name="title">
          {title}
        </slot>
      </div>

      {#if invertX && !noArrow}
        <div class="rotate-180 arrow-left" />
      {/if}
    </div>
  {/if}
</button>

<style>
  .arrow-left {
    border-top: 8px solid transparent;
    border-bottom: 8px solid transparent;
    border-right: 10px solid #00000080;
  }
</style>
